import NextImage from "next/image";

//#region [Props]
type ImageProps = {
	image: string;
	alt: string;
	className?: string;
	width: number;
	height: number;
};

//#endregion

//#region [Component]
/**
 * DO NOT USE FOR SANITY IMAGES
 */
export default function StaticImage({ image, alt, className, width, height }: ImageProps) {

	return <NextImage src={image} alt={alt} className={className} width={width} height={height} unoptimized/>;
}
//#endregion


//#region [Other]
const IS_TMDB_IMAGE = /image\.tmdb\.org/gi;
const IS_LEGACY_FILMWEB_IMAGE = /article(?:\d+)/gi

//#endregion

//#region [Other]

/*
const tmdbImageLoader: ImageLoader = (p) => {

	 Image urls look like this:
	 https://image.tmdb.org/t/p/w92/bk8LyaMqUtaQ9hUShuvFznQYQKR.jpg,
	 https://image.tmdb.org/t/p/w154/bk8LyaMqUtaQ9hUShuvFznQYQKR.jpg,
	 https://image.tmdb.org/t/p/w185/bk8LyaMqUtaQ9hUShuvFznQYQKR.jpg,
	 https://image.tmdb.org/t/p/w342/bk8LyaMqUtaQ9hUShuvFznQYQKR.jpg,
	 https://image.tmdb.org/t/p/w500/bk8LyaMqUtaQ9hUShuvFznQYQKR.jpg

}*/
//#endregion